import { render, staticRenderFns } from "./SpinButton.vue?vue&type=template&id=08d118b2&scoped=true&"
import script from "./SpinButton.vue?vue&type=script&lang=ts&"
export * from "./SpinButton.vue?vue&type=script&lang=ts&"
import style0 from "./SpinButton.vue?vue&type=style&index=0&id=08d118b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d118b2",
  null
  
)

export default component.exports